import _classPrivateMethodInitSpec from "@babel/runtime/helpers/classPrivateMethodInitSpec";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _assertClassBrand from "@babel/runtime/helpers/assertClassBrand";
import { FORM_RENDERER } from "./constants.js";
import { formContainers } from "./expandFormRenderer.js";
var _FormElement_brand = /*#__PURE__*/new WeakSet();
class FormElement extends HTMLElement {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _FormElement_brand);
    _defineProperty(this, "renderRoot", void 0);
  }
  get $$typeof() {
    return "formRenderer";
  }
  validate() {
    _assertClassBrand(_FormElement_brand, this, _proxyFormMethod).call(this, "validate");
  }
  setInitValue() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _assertClassBrand(_FormElement_brand, this, _proxyFormMethod).call(this, "setInitValue", args);
  }
  resetFields() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _assertClassBrand(_FormElement_brand, this, _proxyFormMethod).call(this, "resetFields", args);
  }
  getFieldsValue() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    return _assertClassBrand(_FormElement_brand, this, _proxyFormMethod).call(this, "getFieldsValue", args);
  }
}
function _proxyFormMethod(method) {
  var _this$firstElementChi, _containerElement$tag;
  let args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const containerElement = this.renderRoot !== false ? (_this$firstElementChi = this.firstElementChild) === null || _this$firstElementChi === void 0 ? void 0 : _this$firstElementChi.firstElementChild : this.firstElementChild;
  const tagName = containerElement === null || containerElement === void 0 || (_containerElement$tag = containerElement.tagName) === null || _containerElement$tag === void 0 ? void 0 : _containerElement$tag.toLowerCase();
  if (formContainers.includes(tagName)) {
    return containerElement[method](...args);
  } else {
    // eslint-disable-next-line no-console
    console.error(`no ${method} method in the container element`, {
      container: tagName
    });
  }
}
export function registerFormRenderer() {
  customElements.get(FORM_RENDERER) || customElements.define(FORM_RENDERER, FormElement);
}
//# sourceMappingURL=registerFormRenderer.js.map